module.exports = __webpack_public_path__ + "img/wuhan_center.f8560d68.jpg";